import { useEffect, useRef } from 'react'

// tripla's SDK appends its search bar to the end of <body> as #tripla-searching-app
// and pins it to the middle of the first viewport, on top of the hero image.
// We host the node here instead, so it renders as a bar right under the navbar —
// assets/css/tripla.css undoes the pinning once it lives inside the anchor.
const SEARCH_APP_ID = 'tripla-searching-app'

function TriplaSearchBar() {
    const anchorRef = useRef(null)

    useEffect(() => {
        const anchor = anchorRef.current
        if (!anchor) return undefined

        const moveIntoAnchor = () => {
            const app = document.getElementById(SEARCH_APP_ID)
            if (app && app.parentElement !== anchor) {
                anchor.appendChild(app)
            }
        }

        // The SDK loads async, so watch for the node instead of assuming it is there.
        const observer = new MutationObserver(moveIntoAnchor)
        observer.observe(document.body, { childList: true })
        moveIntoAnchor()

        return () => {
            observer.disconnect()
            // Hand the node back to <body> so React does not tear tripla's app down
            // with the anchor when we leave the public pages.
            const app = document.getElementById(SEARCH_APP_ID)
            if (app && app.parentElement === anchor) {
                document.body.appendChild(app)
            }
        }
    }, [])

    return <div id="tripla-search-anchor" ref={anchorRef} />
}

export default TriplaSearchBar
